<template>
  <div
    class="topbar-container"
    :style="{ width: 'calc(100% - ' + realSidebarWidth + ')', transform: `translateX(calc(-50% + ${realSidebarWidth} * 0.5))` }"
  >
    <div class="left-box">
      <div
        v-if="$store.state.settings.mode == 'mobile' || $store.state.settings.enableSidebarCollapse"
        :class="{
          'sidebar-collapse': true,
          'is-collapse': $store.state.settings.sidebarCollapse,
        }"
        @click="$store.commit('settings/toggleSidebarCollapse')"
      >
        <svg-icon name="collapse" />
      </div>
      <div class="nav_bar">
        <el-tabs type="card" closable v-model="tabModel" @tab-click="tabClick" @tab-remove="tabRemove">
          <template v-for="item in $store.state.keepAlive.list">
            <el-tab-pane
              v-if="item.path != 'reload' && item.path != '/' && item.path != '/home' && formatLabel(item) != ''"
              :key="encodeURIComponent(item.path)"
              :label="formatLabel(item)"
              :name="encodeURIComponent(item.path)"
            >
            </el-tab-pane>
          </template>
        </el-tabs>
      </div>
    </div>
    <UserMenu />
  </div>
</template>

<script>
import { compile } from "path-to-regexp";
import UserMenu from "../UserMenu";
import { routerNames } from "@/router/routes";

export default {
  name: "Breadcrumb",
  props: ["realSidebarWidth"],
  components: {
    UserMenu,
  },
  watch: {
    $route: {
      handler: function(val) {
        this.tabModel = encodeURIComponent(val.fullPath);
      },
    },
  },
  created() {
    this.tabModel = encodeURIComponent(this.$route.path);
    // this.$route.fullPath;
  },
  data() {
    return {
      tabModel: null,
    };
  },
  computed: {
    getAllMenuInfo() {
      var menu = routerNames;
      //   var menu = JSON.parse(
      //     JSON.stringify(this.$store.state.menu.routes)
      //   );
      var tmp = {};
      var find = function(arr) {
        arr.forEach((item, index) => {
          if (!item.children || !item.children.length) {
            // tmp[item.name] = item;
            tmp[item.path] = item;
            //判断递归结束条件
          } else {
            //判断chlidren是否有数据
            find(item.children); //递归调用
          }
        });
      };
      find(menu);
      return tmp;
    },
  },
  methods: {
    formatLabel(item) {
      // debugger
      if (item.name != "reload") {
        if (item.name == "dashboard") {
          return "数据看板";
        } else {
          var name = item.path.replace(/\?.*/, "");
          var obj = this.getAllMenuInfo[name];
          if (obj && obj.meta) {
            if (obj.meta.title) {
              return obj.meta.title || "";
            } else {
              return obj.meta[this.getType(item.path)] || "";
            }
          }
        }
      }
    },
    getType(path) {
      var type = "add";
      var ary = path.split("?");
      if (ary.length == 2) {
        var obj = this.getParams(ary[1]);
        type = obj.pageType ? obj.pageType : type;
      }
      return type;
    },
    getParams(url) {
      var obj = {};

      var strS = url.split("&");
      for (var i = 0; i < strS.length; i++) {
        obj[strS[i].split("=")[0]] = strS[i].split("=")[1];
      }

      return obj;
    },
    tabRemove(name) {
      // console.log(this.tabModel);
      if (name == this.tabModel) {
        var keepAliveList = this.$store.state.keepAlive.list;
        var len = keepAliveList.length - 1;
        var index = -1; //当前关闭的页面位置
        var tempName = decodeURIComponent(name);
        // console.log(tempName)
        keepAliveList.forEach((temp, idx) => {
          if (temp.path == tempName) {
            index = idx;
          }
        });

        if (index > -1) {
          this.$store.commit("keepAlive/remove", tempName);
          keepAliveList = this.$store.state.keepAlive.list;
          len = keepAliveList.length;
          var d;
          if (1 < index && index < len) {
            d = keepAliveList[index];
          } else {
            d = keepAliveList[index - 1];
          }
          console.log(d);
          this.$router.push(d.path);
          console.log("tabRemove=====" + d.path);
          this.tabModel = encodeURIComponent(d.path);
        }
      } else {
        this.$store.commit("keepAlive/remove", decodeURIComponent(name));
      }
    },
    tabClick(item, idx) {
      //   console.log(item)

      console.log("tabClick=====" + item.name);
      //   console.log(item.path)

      this.$router.replace(decodeURIComponent(item.name));
      this.tabModel = item.name;
    },
    pathCompile(path) {
      var toPath = compile(path);
      return toPath(this.$route.params);
    },
  },
};
</script>

<style lang="scss" scoped>
[data-mode="mobile"] {
  .topbar-container {
    width: 100%;
    transform: translateX(-50%);
  }
}
.nav_bar {
  user-select: none;
}
.topbar-container {
  position: fixed;
  z-index: 999;
  // border:1px solid red;
  top: 0;
  right: 0;
  left: 50%;
  width: calc(100% - #{$g_sidebar_width});
  transform: translateX(calc(-50% + #{$g_sidebar_width} * 0.5));
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: $g-topbar-height;
  // background-color: #fff;
  transition: 0.3s, box-shadow 0.2s;
  box-shadow: 0 0 1px 0 #ccc;
  // flex-wrap: wrap;
  &.shadow {
    box-shadow: 0 10px 10px -10px #ccc;
  }
  .nav_bar {
    width: 97% !important;

    // border: 1px solid red;
  }
  .left-box {
    display: flex;
    align-items: center;
    padding-right: 50px;
    overflow: hidden;
    width: 100%;
    background: #f0f2f5;
    background: #ffffff;
    // mask-image: linear-gradient(
    //     90deg,
    //     #000 0%,
    //     #000 calc(100% - 50px),
    //     transparent
    // );
    .sidebar-collapse {
      display: flex;
      align-items: center;
      padding: 0 20px;
      height: 50px;
      cursor: pointer;
      transition: 0.3s;
      &:hover {
        background-image: linear-gradient(to right, #ddd, transparent);
      }
      .svg-icon {
        transition: 0.3s;
      }
      &.is-collapse .svg-icon {
        transform: rotateZ(-180deg);
      }
      & + .el-breadcrumb {
        margin-left: 0;
      }
    }
    ::v-deep .el-breadcrumb {
      margin-left: 20px;
      white-space: nowrap;
      .el-breadcrumb__item {
        display: inline-block;
        float: none;
        span {
          font-weight: normal;
        }
        &:last-child span {
          color: #97a8be;
        }
      }
    }
  }
}
// 面包屑动画
.breadcrumb-enter-active {
  transition: all 0.25s;
}
.breadcrumb-enter,
.breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(30px) skewX(-50deg);
}
</style>
